<template>
    <div id="catalog_container" class="gs:grid">  
        <!-- <div class="backdrop"></div> -->
        <div class="w-full mt-8 md:mt-2">
            <div class="catalog-head">
                <div class="mb-2" style="display: flex; align-items: center; justify-content: space-between">
                    <h1 class="tx-16 md:tx-26 mb-0" style="font-family: montserrat-bold;">
                       Blog Autodeal
                    </h1>
                    <div class="flex" style="justify-content: flex-end">
                        <span class="tx-gray-ad"><a href="/">Home</a> > </span><span class="tx-blue-1">Blog AutoDeal</span>
                    </div>
                </div>
                <h1 class="tx-16 md:tx-26 mb-2">
                   Información para vender más en tu negocio automotríz
                </h1>
                <p class="tx-12 md:tx-16">
                    Encuentra tendencias de mercado, tips para mejorar tus procesos de compra y venta de autos,
                    noticias y mas tips para mantener tu negocio relevante.
                </p>
            </div>
            <div id="catalog_content">
                <div v-for="(item, $index) in this.bodies" :key="$index" class="card-container">
                    <blog-post-card-component :data="item" />
                </div>
            </div>
<!--             <infinite-loading spinner="waveDots" :identifier="infiniteId" @infinite="infiniteHandler" ref="infiniteLoading">
                <div slot="no-more"><span style="visibility: hidden;"></span></div>
                <div slot="no-results"></div>
            </infinite-loading> -->
        </div>
        <div v-if="this.bodies.length > 6" class="flex w-full paging">
            <button v-if="lastPage >= 1" @click="prevPage">Previa</button>
            <button :id="`${first}_page`" :class="{'active': currentPage == first}" @click="getPosts(first)">{{ first }}</button>
            <button v-if="lastPage >= 2" :id="`${second}_page`" :class="{'active': currentPage == second}" @click="getPosts(second)">{{ second }}</button>
            <button v-if="lastPage >= 3" :id="`${third}_page`" :class="{'active': currentPage == third}" @click="getPosts(third)">{{ third }}</button>
            <button>...</button>
            <button @click="getPosts(lastPage)">{{ lastPage }}</button>
            <button @click="nextPage">Siguiente</button>
        </div>
    </div>
  </template>
  <script>
import BlogPostCardComponent from './BlogPostCardComponent.vue';
import metadataService from '../../../../services/metadataService';
  
  export default {
    data: () => ({
        selectedState: '',
        bodies: [],
        total: 0,
        page: 1,
        searchParams: new URLSearchParams('?page=1'),
        infiniteId: +new Date(),
        pages: [],
        prev: null,
        next: null,
        currentPage: 1,
        lastPage: 0,
        first: 1,
        second: 2,
        third: 3,
    }),
  
    components: {
        'blog-post-card-component': BlogPostCardComponent
    },
  
    mounted() {
        // this.searchParams.delete('state_id')
        // this.searchParams.set('page', this.page)
        this.getPosts(1)
    },
    created() {
        metadataService.createMetaDescription('Hojalatería y pintura | AutoDeal',
         'Encuentra los mejores talleres o distribuidores para realizar la hojalatería y pintura de tu auto');
    },
    methods: {
        getPosts(page) {
                const oldCurrentPage = this.currentPage
                // document.getElementById(`${oldCurrentPage}_page`).classList.remove('active')
                const url = `/api/active-blog-posts?page=${page}`
                axios.get(url)
                .then(({ data }) => {
                    if (data.data.length) {
                        // this.searchParams.set('page', parseInt(this.searchParams.get('page'), 10) + 1);
                        this.prev = data.links.prev
                        this.next = data.links.next
                        this.lastPage = data.meta.last_page

                        // const numberOfPages = this.lastPage < 4 ? this.lastPage : 3
                        // const size = this.lastPage - page
                        // console.log(size);
                        // this.pages = Array.from({length: size}, (_, i) => i+1).slice((page-1), 3)

                        this.currentPage = data.meta.current_page

                        this.total = data.data.length 
                        this.bodies = data.data
                    }

                if(this.currentPage <= this.lastPage && page >= 1) {
                    if(page > oldCurrentPage && this.third < this.lastPage) {
                        this.first++
                        this.second++
                        this.third++
                    } 
                    else if(page < oldCurrentPage && this.first > 1) {
                        this.first--
                        this.second--
                        this.third--
                    }
                }
            })
        },
        prevPage() {
            if(this.prev) this.getPosts(this.currentPage - 1)
        },
        nextPage() {
            if(this.next) this.getPosts(this.currentPage + 1)
        }
    },
    watch: {
        selectedState(value) {
            this.searchParams.set('page', 1)
            this.searchParams.set('state_id', value)
            this.bodies = []
            this.infiniteId += 1
        }
    }
  }
  </script>
  <style lang="css">
  
    @media (min-width: 1280px) {
        .main__wrapper {
            min-width: 100vw;
        }
    }
  
    @media (min-width: 768px) {
        .main__wrapper {
            min-width: 100vw;
        }
        .mt-2 {
            margin-top: 0;
        }
    }
  
    @media (max-width: 542px) {
        .header__search__filters {
            width: 80%;
            right: none;
        }
        .header__filters {
            width: 20%;
            position: absolute;
            right: 0;
            top: 46px;
            background: #000000;
            padding: 8px 0 10px 12px;
            border-bottom: 1px solid #000000;
  
        }
        .mr-1 {
            margin-right: 0;
        }
    }
  </style>
  
  <style scoped>
  .catalog-title {
    position: relative;
    text-transform: uppercase;
    font-size: calc(62.5% * 4);
    /* text-shadow: 0 0 50px #000000b8, 0 0 80px #000000b8, 0 0 100px #000000bf; */
  }

  #catalog_container {
    position: relative;
    min-height: 100vh;
  }
  #catalog_container::before {
    z-index: -1;
    content: "";
    position: absolute;
    top: 0; 
    left: 0;
    width: 100%; 
    height: 100%;
    /* background: url(../../../../../images/body-bg.jpg), #c9c8c438; */
    background-position: 28% top;
    margin-top: -6px;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .catalog-head {
        padding: 20px 35px;
    }
  @media screen and (min-width: 1024px) {
      .catalog-head {
          padding: 20px 50px;
      }
  }

#catalog_content {
    scrollbar-gutter: stable;
    padding: 26px 35px;
    overflow-y: auto;
    position: relative;
    display: grid;
    justify-content: center;
    gap: 30px;
    grid-template-columns: repeat(auto-fill, 300px);
}

@media screen and (min-width: 420px) {
    #catalog_content {
        justify-content: start;
    }
}

@media screen and (min-width: 1024px) {
    #catalog_content {
        padding: 26px 50px;
        grid-template-columns: repeat(auto-fill, 420px);
    }
}

#catalog_state_filter_group {
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    border-radius: 5px;
    background-color: #fff;
    max-width: 100%;
    z-index: 2;
    grid-row: 1 / 2;
    grid-column: 1 / -1;
}

#catalog_state_filter {
    position: relative;
    z-index: 2;
    color: #818181;
    border: none;
}

  @media screen and (min-width: 1024px) {
    #catalog_state_filter_group {
        /* margin: 10px 8%; */
        max-width: 250px;
    }
    #catalog_container::before {
        background-size: cover;
        background-repeat: no-repeat;
    }
    #catalog_content {
        flex-direction: row;
        align-content: start;
        padding-top: 20px;
    }
  }

  .hot-deal-2{
    text-align: center;
    color: white;
    background-color: black;
    padding: 4px;
    border-radius: 5px;
  }
  .img-bd{
    max-width: 100px;
  }

.paging {
    align-items: end;
    padding: 0 5px;
}
@media screen and (min-width: 1024px) {
    .paging {
        width: 50%;
        margin: 0 auto;
    }
}
.paging > button:not(:last-child) {
    margin-right: 5px;
}
.paging > button {
    font-size: 1.2rem;
    flex: 1;
    padding: 4px 8px;
    color: rgb(94, 94, 94);
    font-weight: bold;
    border-radius: 5px;
}

.paging > button.active {
    background: #b5d1ff;
}

  </style>
  